import * as THREE from "three";
import * as cuBuilding from "../../../redux/reducers/building_pricing/pricingReducer";
import * as utils from "../../../redux/reducers/utils";
import { updateBreezewayFrameAndStorages } from "../../common/common.helper";
import {
	makeDimensionUpdateRight,
	makeDimensionUpdateFront,
	makeDimensionUpdateLeft,
	makeDimensionUpdateBack,
	updateTemplateWidthR,
	updateTemplateWidthB,
	updateTemplateWidthL,
	updateTemplateWidthF
} from "../../lean_building_pricing/leanBuilding.helper";
import { const_var, params } from "../../../redux/reducers/reducer";
import { updateBracingSelection } from "../../building_component/buildingComponent.helper";
export const makeDimensionArray = (state) => {
	state.const_var.buildingWidthArray = [];
	state.const_var.buildingLengthArray = [];
	state.const_var.buildingHeightArray = [];
	state.const_var.buildingWidthArrayCust = [];
	state.const_var.buildingLengthArrayCust = [];
	let b_m_i_h = 0;
	const Widthoptions = [
		{
			label: "Standard",
			options: []
		},
		{
			label: "Custom",
			options: []
		}
	];
	let chkFixedWidthFlag = false;
	let chkFixedWidthFlagNew = false;

	state.const_var.roof_style.map((val, i) => {
		let widthRange;

		if (state.params.p_r_s == val.roof_id) {
			let minHeightValue = params.singleSlope == true ? val.start_height : val.min_height;

			if (
				(state.params.m_s_n == 3 || state.params.m_s_n == 153 || state.params.m_s_n == 9 || state.params.m_s_n == 33) &&
				const_var.checkmoreCustomizeFlag != true &&
				!const_var.b_o_J_1[params.p_b_t].includes("Free Standing") &&
				!const_var.b_o_J_1[params.p_b_t].includes("RV Covers")
			) {
				if (state.const_var.crmSetting.is_Edit == false) {
					state.const_var.isForStandardBuilding = true;
				}
				if (state.const_var.crmSetting.is_Edit == true) {
					if (
						const_var.editAPIDataByResponse != undefined &&
						const_var.editAPIDataByResponse.data != undefined &&
						const_var.editAPIDataByResponse.data.request_data != undefined &&
						const_var.editAPIDataByResponse.data.request_data.building != undefined &&
						const_var.editAPIDataByResponse.data.request_data.building.create_at_date != undefined
					) {
						if (
							((state.params.m_s_n != 33 && const_var.editAPIDataByResponse.data.request_data.building.create_at_date >= "2024-07-01") ||
								(state.params.m_s_n == 33 && const_var.editAPIDataByResponse.data.request_data.building.create_at_date >= "2024-07-09")) &&
							minHeightValue != undefined &&
							parseInt(minHeightValue) <= parseInt(state.params.p_w)
						) {
							state.const_var.isForStandardBuilding = true;
						} else {
							state.const_var.isForStandardBuilding = false;
						}
					} else if (
						const_var.editAPIDataByResponse != undefined &&
						const_var.editAPIDataByResponse.data != undefined &&
						const_var.editAPIDataByResponse.data.main_created_at != undefined &&
						((state.params.m_s_n != 33 && const_var.editAPIDataByResponse.data.main_created_at >= "2024-07-01") ||
							(state.params.m_s_n == 33 && const_var.editAPIDataByResponse.data.main_created_at >= "2024-07-09")) &&
						minHeightValue != undefined &&
						parseInt(minHeightValue) <= parseInt(state.params.p_w)
					) {
						state.const_var.isForStandardBuilding = true;
					} else {
						if (const_var.editAPIDataByResponse?.data?.main_created_at == undefined && const_var.editAPIDataByResponse?.data?.request_data?.building?.create_at_date == undefined) {
							state.const_var.isForStandardBuilding = true;
						} else {
							state.const_var.isForStandardBuilding = false;
						}
					}
				}

				if (
					const_var.editAPIDataByResponse != undefined &&
					const_var.editAPIDataByResponse.data != undefined &&
					const_var.editAPIDataByResponse.data.request_data != undefined &&
					const_var.editAPIDataByResponse.data.request_data.building != undefined &&
					const_var.editAPIDataByResponse.data.request_data.building.manufacturer == state.params.m_s_n &&
					const_var.editAPIDataByResponse.data.request_data.building.state == state.params.p_s_n &&
					const_var.editAPIDataByResponse.data.request_data.building.create_at_date != undefined
				) {
					if (
						((state.params.m_s_n != 33 && const_var.editAPIDataByResponse.data.request_data.building.create_at_date >= "2024-07-01") ||
							(state.params.m_s_n == 33 && const_var.editAPIDataByResponse.data.request_data.building.create_at_date >= "2024-07-09")) &&
						minHeightValue != undefined &&
						parseInt(minHeightValue) <= parseInt(state.params.p_w)
					) {
						state.const_var.isForStandardBuilding = true;
					} else {
						state.const_var.isForStandardBuilding = false;
					}
				} else {
					if (
						const_var.editAPIDataByResponse != undefined &&
						const_var.editAPIDataByResponse.data != undefined &&
						const_var.editAPIDataByResponse.data.request_data != undefined &&
						const_var.editAPIDataByResponse.data.request_data.building != undefined &&
						const_var.editAPIDataByResponse.data.main_created_at != undefined &&
						((state.params.m_s_n != 33 && const_var.editAPIDataByResponse.data.main_created_at < "2024-07-01") ||
							(state.params.m_s_n == 33 && const_var.editAPIDataByResponse.data.main_created_at < "2024-07-09"))
					) {
						state.const_var.isForStandardBuilding = false;
					}
				}
				if (const_var.isForStandardBuilding == true && const_var.a_p_d_a != undefined && const_var.a_p_d_a.length > 0) {
					if (params.p_h && parseFloat(params.p_h) > parseFloat(state.params.p_w) && minHeightValue != undefined && parseInt(minHeightValue) <= parseInt(state.params.p_w)) {
						changeBuildingDimension({ val: state.params.p_w, str: "h" });
					}
				}
			}
			if (const_var.b_o_J_1[params.p_b_t].includes("Free Standing") || const_var.b_o_J_1[params.p_b_t].includes("RV Covers")) {
				state.const_var.isForStandardBuilding = false;
			}

			let minStartWidthRange = val.min_start_width;

			if (val.fixed_width != undefined && val.fixed_width != null) {
				let splitRecord = val.fixed_width.split(",");
				if (splitRecord.length > 0) {
					chkFixedWidthFlag = true;
					const arr1 = [],
						arr2 = [];
					splitRecord.map((data, index) => {
						arr1.push({ value: data, label: data });
						arr2.push({ value: data, label: data });
					});
					state.const_var.buildingWidthArray = arr1;
					state.const_var.buildingWidthArrayCust = arr2;
				}
			} else {
				if (minStartWidthRange != undefined) {
					const_var.BuildingMinWidth[val.roof_id] = minStartWidthRange;

					const arr1 = [],
						arr2 = [];
					Array.apply(null, { length: val.max_width + 1 })
						.map(Number.call, Number)
						.slice(minStartWidthRange)
						.map((val, index) => {
							if (params.m_s_n == 100000 && params.p_w != 14 && params.p_w != 16) {
								if (val != 14 && val != 16) {
									arr1.push({ value: val, label: val });
									arr2.push({ value: val, label: val });
								}
							} else {
								arr1.push({ value: val, label: val });
								arr2.push({ value: val, label: val });
							}
						});
					state.const_var.buildingWidthArray = arr1;
					state.const_var.buildingWidthArrayCust = arr2;
					const arr3 = [],
						arr4 = [];
					for (let i = minStartWidthRange; i <= val.max_width; i++) {
						if (params.m_s_n == 100000 && params.p_w != 14 && params.p_w != 16) {
							if (i == 14 || i == 16) {
								continue;
							}
						}
						if ((i - minStartWidthRange) % val.distance_on_width === 0) {
							arr3.push({
								label: i,
								value: i
							});
						} else {
							arr4.push({
								label: i,
								value: i
							});
						}
					}
					Widthoptions[0].options = arr3;
					Widthoptions[1].options = arr4;
				} else {
					const_var.BuildingMinWidth[val.roof_id] = val.min_width;
					const arr1 = [],
						arr2 = [];
					Array.apply(null, { length: val.max_width + 1 })
						.map(Number.call, Number)
						.slice(val.min_width)
						.map((val, index) => {
							if (params.m_s_n == 100000 && params.p_w != 14 && params.p_w != 16) {
								if (val != 14 && val != 16) {
									arr1.push({ value: val, label: val });
									arr2.push({ value: val, label: val });
								}
							} else {
								arr1.push({ value: val, label: val });
								arr2.push({ value: val, label: val });
							}
						});
					state.const_var.buildingWidthArray = arr1;
					state.const_var.buildingWidthArrayCust = arr2;
					const arr3 = [],
						arr4 = [];
					for (let i = val.min_width; i <= val.max_width; i++) {
						if (params.m_s_n == 100000 && params.p_w != 14 && params.p_w != 16) {
							if (i == 14 || i == 16) {
								continue;
							}
						}
						if ((i - val.min_width) % val.distance_on_width === 0) {
							arr3.push({
								label: i,
								value: i
							});
						} else {
							arr4.push({
								label: i,
								value: i
							});
						}
					}
					Widthoptions[0].options = arr3;
					Widthoptions[1].options = arr4;
				}
			}
		}
	});

	if (Widthoptions[1].options.length == 0) {
		Widthoptions.splice(1, 1);
	}

	state.const_var.buildingWidthArray = chkFixedWidthFlag == false ? Widthoptions : state.const_var.buildingWidthArray;
	const Lengthoptions = [
		{
			label: "Standard",
			options: []
		},
		{
			label: "Custom",
			options: []
		}
	];
	state.const_var.roof_style.map((val, i) => {
		state.const_var.arrayendLengthRoof[val.roof_id] = val.building_max_length;
		if (state.params.p_r_s == val.roof_id) {
			const arr1 = [],
				arr2 = [];
			Array.apply(null, { length: val.building_max_length + 1 })
				.map(Number.call, Number)
				.slice(val.min_start_length)
				.map((val, index) => {
					arr1.push({ value: val, label: val });
					arr2.push({ value: val, label: val });
				});
			if (arr1.length) {
				state.const_var.buildingLengthArray = arr1;
			}
			if (arr2.length) {
				state.const_var.buildingLengthArrayCust = arr2;
			}
			if (params.isBreezeway) {
				for (let i = val.min_start_length; i <= val.building_max_length; i++) {
					if ((i - val.min_start_length) % const_var.DistanceArr[params.p_b_t][params.p_r_s] === 0) {
						Lengthoptions[0].options.push({
							label: i,
							value: i
						});
					}
				}

				let dropDownValues = Lengthoptions[0].options;
				let checkMatch = Lengthoptions[0].options.find((element) => element.value == params.p_d);

				if (checkMatch == undefined) {
					let closest =
						dropDownValues.length > 0 &&
						dropDownValues.reduce((a, b) => {
							return Math.abs(b.value - params.p_d) < Math.abs(a.value - params.p_d) ? b : a;
						});
					params.p_d = closest.value;

					if (params.checkeditName != true) {
						let newVal = params.building_type_name + " - " + params.p_w + " x " + params.p_d + " x " + params.p_h;
						params.other_building_type_name = newVal;
						if (const_var.post_data.building != undefined) {
							const_var.post_data.building.other_building_type_name = params.other_building_type_name;
							const_var.post_data.building.name = params.other_building_type_name;
						}
					}
				}
			} else {
				const arr3 = [],
					arr4 = [];
				for (let i = val.min_start_length; i <= val.building_max_length; i++) {
					if ((i - val.min_start_length) % val.distance_on_length === 0) {
						arr3.push({
							label: i,
							value: i
						});
					} else {
						arr4.push({
							label: i,
							value: i
						});
					}
					Lengthoptions[0].options = arr3;
					Lengthoptions[1].options = arr4;
				}
			}
		}
	});
	state.const_var.buildingLengthArray = Lengthoptions;
	state.const_var.roof_style.map((val, i) => {
		let heightRange;
		if (state.params.p_r_s == val.roof_id) {
			let minHeightValue = params.singleSlope == true ? val.start_height : val.min_height;

			if (
				(state.params.m_s_n == 3 || state.params.m_s_n == 153 || state.params.m_s_n == 9 || state.params.m_s_n == 33) &&
				const_var.checkmoreCustomizeFlag != true &&
				!const_var.b_o_J_1[params.p_b_t].includes("Free Standing") &&
				!const_var.b_o_J_1[params.p_b_t].includes("RV Covers")
			) {
				if (state.const_var.crmSetting.is_Edit == false) {
					state.const_var.isForStandardBuilding = true;
				}
				if (state.const_var.crmSetting.is_Edit == true) {
					if (
						const_var.editAPIDataByResponse != undefined &&
						const_var.editAPIDataByResponse.data != undefined &&
						const_var.editAPIDataByResponse.data.request_data != undefined &&
						const_var.editAPIDataByResponse.data.request_data.building != undefined &&
						const_var.editAPIDataByResponse.data.request_data.building.create_at_date != undefined
					) {
						if (
							((state.params.m_s_n != 33 && const_var.editAPIDataByResponse.data.request_data.building.create_at_date >= "2024-07-01") ||
								(state.params.m_s_n == 33 && const_var.editAPIDataByResponse.data.request_data.building.create_at_date >= "2024-07-09")) &&
							minHeightValue != undefined &&
							parseInt(minHeightValue) <= parseInt(state.params.p_w)
						) {
							state.const_var.isForStandardBuilding = true;
						} else {
							state.const_var.isForStandardBuilding = false;
						}
					} else if (
						const_var.editAPIDataByResponse != undefined &&
						const_var.editAPIDataByResponse.data != undefined &&
						const_var.editAPIDataByResponse.data.main_created_at != undefined &&
						((state.params.m_s_n != 33 && const_var.editAPIDataByResponse.data.main_created_at >= "2024-07-01") ||
							(state.params.m_s_n == 33 && const_var.editAPIDataByResponse.data.main_created_at >= "2024-07-09")) &&
						minHeightValue != undefined &&
						parseInt(minHeightValue) <= parseInt(state.params.p_w)
					) {
						state.const_var.isForStandardBuilding = true;
					} else {
						if (const_var.editAPIDataByResponse?.data?.main_created_at == undefined && const_var.editAPIDataByResponse?.data?.request_data?.building?.create_at_date == undefined) {
							state.const_var.isForStandardBuilding = true;
						} else {
							state.const_var.isForStandardBuilding = false;
						}
					}
				}
				if (
					const_var.editAPIDataByResponse != undefined &&
					const_var.editAPIDataByResponse.data != undefined &&
					const_var.editAPIDataByResponse.data.request_data != undefined &&
					const_var.editAPIDataByResponse.data.request_data.building != undefined &&
					const_var.editAPIDataByResponse.data.request_data != undefined &&
					const_var.editAPIDataByResponse.data.request_data.building != undefined &&
					const_var.editAPIDataByResponse.data.request_data.building.manufacturer == state.params.m_s_n &&
					const_var.editAPIDataByResponse.data.request_data.building.state == state.params.p_s_n &&
					const_var.editAPIDataByResponse.data.request_data.building.create_at_date != undefined
				) {
					if (
						((state.params.m_s_n != 33 && const_var.editAPIDataByResponse.data.request_data.building.create_at_date >= "2024-07-01") ||
							(state.params.m_s_n == 33 && const_var.editAPIDataByResponse.data.request_data.building.create_at_date >= "2024-07-09")) &&
						minHeightValue != undefined &&
						parseInt(minHeightValue) <= parseInt(state.params.p_w)
					) {
						state.const_var.isForStandardBuilding = true;
					} else {
						state.const_var.isForStandardBuilding = false;
					}
				} else {
					if (
						const_var.editAPIDataByResponse != undefined &&
						const_var.editAPIDataByResponse.data != undefined &&
						const_var.editAPIDataByResponse.data.request_data != undefined &&
						const_var.editAPIDataByResponse.data.request_data.building != undefined &&
						const_var.editAPIDataByResponse.data.main_created_at != undefined &&
						((state.params.m_s_n != 33 && const_var.editAPIDataByResponse.data.main_created_at < "2024-07-01") ||
							(state.params.m_s_n == 33 && const_var.editAPIDataByResponse.data.main_created_at < "2024-07-09"))
					) {
						state.const_var.isForStandardBuilding = false;
					}
				}
			}
			if (const_var.b_o_J_1[params.p_b_t].includes("Free Standing") || const_var.b_o_J_1[params.p_b_t].includes("RV Covers")) {
				state.const_var.isForStandardBuilding = false;
			}

			{
				b_m_i_h = val.min_height;
			}

			let maxHeight = val.max_height;
			if (state.const_var.isForStandardBuilding == true && maxHeight > state.params.p_w && minHeightValue != undefined && parseInt(minHeightValue) <= parseInt(state.params.p_w)) {
				maxHeight = state.params.p_w;
			}

			if (params.singleSlope == true) {
				console.log("enter");
				if (
					val.min_height != maxHeight &&
					const_var.c_m_a[params.p_b_t] != undefined &&
					const_var.c_m_a[params.p_b_t].fixed_new_leg_width != undefined &&
					const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length > 0 &&
					state.const_var.c_m_a[params.p_b_t].fixed_new_leg_width[0][params.p_w] !== undefined
				) {
					let filterData = state.const_var.c_m_a[params.p_b_t].fixed_new_leg_width[0][params.p_w];
					heightRange = Array.apply(null, { length: filterData.max_height + 1 })
						.map(Number.call, Number)
						.slice(filterData.min_height)
						.map((val, index) => {
							state.const_var.buildingHeightArray.push({ value: val, label: chkFixedWidthFlag == true ? val + " x " + (filterData.min_smaller_height + index) : val });
						});
					let chkHeight = state.const_var.buildingHeightArray.filter((data) => data.value == params.p_h);
					if (chkHeight.length == 0) {
						params.p_h = state.const_var.buildingHeightArray[0].value;
					}
				} else {
					if (
						const_var.editAPIDataByResponse.data != undefined &&
						const_var.editAPIDataByResponse.data.request_data.building !== undefined &&
						(!isNaN(const_var.editAPIDataByResponse.data.request_data.building?.height) || const_var.editAPIDataByResponse.data.request_data.building?.height.includes("x") == false)
					) {
						chkFixedWidthFlag = false;
					}
					heightRange = Array.apply(null, { length: maxHeight + 1 })
						.map(Number.call, Number)
						.slice(val.start_height)
						.map((val, index) => {
							if (index > 0 && Math.round(val - params.p_r_p) >= b_m_i_h) {
								state.const_var.buildingHeightArray.push({ value: val, label: chkFixedWidthFlag == true ? val + " x " + parseInt(Math.round(val - params.p_r_p)) : val });
							} else {
								state.const_var.buildingHeightArray.push({ value: val, label: chkFixedWidthFlag == true ? val + " x " + parseInt(Math.round(val - params.p_r_p)) : val });
							}
						});
				}
				if (const_var.crmSetting.is_Edit != true) {
					const_var.UpdatedPriceData.certificate_price_changed = true;
				}
			} else {
				let heightArray = [];
				heightRange = Array.apply(null, { length: maxHeight + 1 })
					.map(Number.call, Number)
					.slice(b_m_i_h)
					.map((val, index) => {
						heightArray.push({ value: val, label: val });
					});
				if (heightArray.length) {
					state.const_var.buildingHeightArray = JSON.parse(JSON.stringify(heightArray));
				}
			}
		}
	});

	if ((state.params.p_r_s == "4" || state.params.p_r_s == "5") && state.params.p_b_t == "2") {
		state.params.p_l_w = state.params.p_l_w != "Open" ? state.params.p_l_w : 1;
		state.params.p_r_w = state.params.p_r_w != "Open" ? state.params.p_r_w : 1;
	} else {
		state.params.p_l_w = state.params.p_l_w;
		state.params.p_r_w = state.params.p_r_w;
	}
};

export const changeBuildingDimension = (state, value, str, secondParam, checkCustomDimension, valueToSet, from, reducerFns = {}) => {
	const { dynamicWallOptions, dynamicWallOptionsForLeanTo, reSelExtEle, roofStyleChange, updateJTrim } = reducerFns;

	for (const key in params) {
		params.params_cancel[key] = params[key];
	}
	const_var.ExtraItemsFeaturesArray.map((item, i) => {
		if (item != null && item != undefined && item.sheet_type == "side" && item.is_edit == true && item.label.toLowerCase().includes("side")) {
			const_var.ExtraItemsFeaturesArray[i].cost = const_var.a_p_d_a.overhang.side[0].cost;
			const_var.ExtraItemsFeaturesArray[i].is_edit = false;
		}
	});
	utils.update26GAUpgradePrice();
	const_var.CheckDefaultLoadForTween = false;
	if (checkCustomDimension != undefined) {
		const_var.lengthData.center.previousWidth = state.params.p_w;
		state.params.p_w = parseInt(value);
		const_var.UpdatedPriceData.roof_style_price_changed = true;
		const_var.UpdatedPriceData.certificate_price_changed = true;
		const_var.UpdatedPriceData.front_wall_price_changed = true;
		const_var.UpdatedPriceData.back_wall_price_changed = true;
		const_var.UpdatedPriceData.common_width_changed = true;
		const_var.UpdatedPriceData.wainscot_price_changed = true;
		const_var.UpdatedPriceData.wainscot_price_changed = true;

		const_var.UpdatedPriceData.roof_color_price_changed = true;
		const_var.UpdatedPriceData.wall_color_price_changed = true;
		const_var.UpdatedPriceData.trim_color_price_changed = true;
		const_var.UpdatedPriceData.truss_price_changed = undefined;
		const_var.UpdatedPriceData.frontLean_truss_price_changed = true;
		const_var.UpdatedPriceData.backLean_truss_price_changed = true;
		const_var.UpdatedPriceData.rightLean_truss_price_changed = true;
		const_var.UpdatedPriceData.leftLean_truss_price_changed = true;
		const_var.UpdatedPriceData.common_left_lean_width_changed = true;
		const_var.UpdatedPriceData.common_right_lean_width_changed = true;
		const_var.UpdatedPriceData.common_front_lean_width_changed = true;
		const_var.UpdatedPriceData.common_back_lean_width_changed = true;

		if (const_var.b_r_p_a[params.b_r_p] != undefined && const_var.b_r_p_a[params.b_r_p].cost_type == "%") {
			const_var.UpdatedPriceData.roof_pitch_price_changed = true;
		}
		const_var.lengthData.center.previousLength = state.params.p_d;
		state.params.p_d = parseInt(secondParam);
		const_var.lengthData.center.length = state.params.p_d;
		if (state.params.p_d > state.const_var.arrayendLengthRoof[params.p_r_s] && "Vertical" != state.const_var.TypeEnum[state.params.p_r_s]) {
			state.params.p_r_s = 3;
			for (var i = 0; i <= const_var.roof_style.length - 1; i++) {
				if (state.const_var.roof_style[i].roof_id == state.params.p_r_s) {
					roofStyleChange(state, i, true, true);
				}
			}
		}
		const_var.UpdatedPriceData.connection_fee_end_changed = true;
		const_var.UpdatedPriceData.left_front_wrap_connection_fee_changed = true;
		const_var.UpdatedPriceData.right_front_wrap_connection_fee_changed = true;
		const_var.UpdatedPriceData.right_back_wrap_connection_fee_changed = true;
		const_var.UpdatedPriceData.left_back_wrap_connection_fee_changed = true;
		const_var.UpdatedPriceData.roof_style_price_changed = true;
		const_var.UpdatedPriceData.height_price_changed = true;
		const_var.UpdatedPriceData.roof_pitch_price_changed = true;
		const_var.UpdatedPriceData.certificate_price_changed = true;
		const_var.UpdatedPriceData.right_wall_price_changed = true;
		const_var.UpdatedPriceData.left_wall_price_changed = true;
		const_var.UpdatedPriceData.left_wall_cut_panel_price_changed = true;
		const_var.UpdatedPriceData.right_wall_cut_panel_price_changed = true;
		const_var.UpdatedPriceData.common_length_changed = true;
		const_var.UpdatedPriceData.wainscot_price_changed = true;
		const_var.UpdatedPriceData.truss_price_changed = true;
		const_var.UpdatedPriceData.frontLean_truss_price_changed = true;
		const_var.UpdatedPriceData.backLean_truss_price_changed = true;
		const_var.UpdatedPriceData.rightLean_truss_price_changed = true;
		const_var.UpdatedPriceData.leftLean_truss_price_changed = true;
		const_var.UpdatedPriceData.common_left_lean_length_changed = true;
		const_var.UpdatedPriceData.common_right_lean_length_changed = true;
		const_var.UpdatedPriceData.common_front_lean_length_changed = true;
		const_var.UpdatedPriceData.common_back_lean_length_changed = true;
		updateTemplateWidthL();
		updateTemplateWidthR();
		updateTemplateWidthF();
		updateTemplateWidthB();

		if (state.params.add_left_front_lean_porch == true && state.params.add_right_front_lean_porch == true) {
			state.params.leanF_p_d = state.params.p_w;
		}

		if (state.params.add_right_back_lean_porch == true && state.params.add_left_back_lean_porch == true) {
			state.params.leanB_p_d = state.params.p_w;
		}

		if (state.params.add_left_front_lean_porch == true && state.params.add_left_back_lean_porch == true) {
			state.params.lean_p_d = state.params.p_d;
		}

		if (state.params.add_right_back_lean_porch == true && state.params.add_right_front_lean_porch == true) {
			state.params.leanR_p_d = state.params.p_d;
		}
		if (state.params.add_left_front_lean_porch == true && state.params.leantoAlignmentFront != "2" && params.p_w != params.leanF_p_d) {
			state.params.add_left_front_lean_porch = false;
		}

		if (state.params.add_right_front_lean_porch == true && state.params.leantoAlignmentFront != "3" && params.p_w != params.leanF_p_d) {
			state.params.add_right_front_lean_porch = false;
		}

		if (state.params.add_left_back_lean_porch == true && state.params.leantoAlignmentBack != "3" && params.p_w != params.leanB_p_d) {
			state.params.add_left_back_lean_porch = false;
		}

		if (state.params.add_right_back_lean_porch == true && state.params.leantoAlignmentBack != "2" && params.p_w != params.leanB_p_d) {
			state.params.add_right_back_lean_porch = false;
		}
		if (state.params.add_left_front_lean_porch == true && state.params.leantoAlignmentLeft != "2" && params.p_d != params.lean_p_d) {
			state.params.add_left_front_lean_porch = false;
		}

		if (state.params.add_left_back_lean_porch == true && state.params.leantoAlignmentLeft != "3" && params.p_d != params.lean_p_d) {
			state.params.add_left_back_lean_porch = false;
		}

		if (state.params.add_right_front_lean_porch == true && state.params.leantoAlignmentRight != "2" && params.p_d != params.lean_p_d) {
			state.params.add_right_front_lean_porch = false;
		}

		if (state.params.add_right_back_lean_porch == true && state.params.leantoAlignmentRight != "3" && params.p_d != params.lean_p_d) {
			state.params.add_right_back_lean_porch = false;
		}

		let lstPos = 0;
		let currPos = 0;

		if (params.leantoAlignmentFront == "1") currPos = 0;
		if (params.leantoAlignmentFront == "3") currPos = params.p_w / 2 - params.leanF_p_d / 2;
		if (params.leantoAlignmentFront == "2") currPos = -params.p_w / 2 + params.leanF_p_d / 2;
		if (lstPos != currPos) {
			const diff = currPos - lstPos;
			const_var.entry_points.forEach((e) => {
				if (e.component_wall_name == "F_L_F_W" || e.component_wall_name == "F_L_F_S_W") e.entry_position.x += diff;
			});
		}

		if (params.p_u_c) {
			const_var.newDoorsArray.forEach((e) => {
				if (e.userData.wallName == "c_b_r_s_w") {
					e.positionX += (params.p_d - const_var.lengthData.center.previousLength) / 2;
				} else if (e.userData.wallName == "c_b_l_s_w") {
					e.positionX += (const_var.lengthData.center.previousLength - params.p_d) / 2;
				}
			});
		}

		const_var.newDoorsArray.forEach((e) => {
			if (["L_L_F_W", "L_L_F_S_W"].includes(e.userData.wallName)) e.positionX += -params.p_w / 2 - params.lean_p_w / 2 - (-const_var.lengthData.center.previousWidth / 2 - params.lean_p_w / 2);
		});
		const_var.entry_points.forEach((e) => {
			if (["L_L_F_W", "L_L_F_S_W"].includes(e.component_wall_name)) e.entry_position.positionX += -params.p_w / 2 - params.lean_p_w / 2 - (-const_var.lengthData.center.previousWidth / 2 - params.lean_p_w / 2);
		});
		//
		const_var.newDoorsArray.forEach((e) => {
			if ("L_L_B_W".includes(e.userData.wallName)) e.positionX -= -params.p_w / 2 - params.lean_p_w / 2 - (-const_var.lengthData.center.previousWidth / 2 - params.lean_p_w / 2);
		});
		const_var.entry_points.forEach((e) => {
			if ("L_L_B_W".includes(e.component_wall_name)) e.entry_position.positionX -= -params.p_w / 2 - params.lean_p_w / 2 - (-const_var.lengthData.center.previousWidth / 2 - params.lean_p_w / 2);
		});
		//
		const_var.newDoorsArray.forEach((e) => {
			if (["R_L_F_W", "R_L_F_S_W"].includes(e.userData.wallName)) e.positionX += params.p_w / 2 + params.leanR_p_w / 2 - (const_var.lengthData.center.previousWidth / 2 + params.lean_p_w / 2);
		});
		const_var.entry_points.forEach((e) => {
			if (["R_L_F_W", "R_L_F_S_W"].includes(e.component_wall_name)) e.entry_position.positionX += params.p_w / 2 + params.leanR_p_w / 2 - (const_var.lengthData.center.previousWidth / 2 + params.lean_p_w / 2);
		});
		//
		const_var.newDoorsArray.forEach((e) => {
			if (["R_L_B_W"].includes(e.userData.wallName)) e.positionX -= params.p_w / 2 + params.leanR_p_w / 2 - (const_var.lengthData.center.previousWidth / 2 + params.lean_p_w / 2);
		});
		const_var.entry_points.forEach((e) => {
			if (["R_L_B_W"].includes(e.component_wall_name)) e.entry_position.positionX -= params.p_w / 2 + params.leanR_p_w / 2 - (const_var.lengthData.center.previousWidth / 2 + params.lean_p_w / 2);
		});
		//
		const_var.newDoorsArray.forEach((e) => {
			if (["B_L_B_W"].includes(e.userData.wallName)) e.positionX += -params.p_d / 2 - params.leanB_p_w / 2 - (-const_var.lengthData.center.previousLength / 2 - params.leanB_p_w / 2);
		});
		const_var.entry_points.forEach((e) => {
			if (["B_L_B_W"].includes(e.component_wall_name)) e.entry_position.positionX += -params.p_d / 2 - params.leanB_p_w / 2 - (-const_var.lengthData.center.previousLength / 2 - params.leanB_p_w / 2);
		});
		//
		const_var.newDoorsArray.forEach((e) => {
			if (["B_L_F_W", "B_L_L_S_W"].includes(e.userData.wallName)) e.positionX -= -params.p_d / 2 - params.leanB_p_w / 2 - (-const_var.lengthData.center.previousLength / 2 - params.leanB_p_w / 2);
		});
		const_var.entry_points.forEach((e) => {
			if (["B_L_F_W", "B_L_L_S_W"].includes(e.component_wall_name)) e.entry_position.positionX -= -params.p_d / 2 - params.leanB_p_w / 2 - (-const_var.lengthData.center.previousLength / 2 - params.leanB_p_w / 2);
		});
		//
		const_var.newDoorsArray.forEach((e) => {
			if (["F_L_L_W"].includes(e.userData.wallName)) e.positionX += params.p_d / 2 + params.leanF_p_w / 2 - (const_var.lengthData.center.previousLength / 2 + params.leanF_p_w / 2);
		});
		const_var.entry_points.forEach((e) => {
			if (["F_L_L_W"].includes(e.component_wall_name)) e.entry_position.positionX += params.p_d / 2 + params.leanF_p_w / 2 - (const_var.lengthData.center.previousLength / 2 + params.leanF_p_w / 2);
		});
		//
		const_var.newDoorsArray.forEach((e) => {
			if (["F_L_R_W", "F_L_R_S_W"].includes(e.userData.wallName)) e.positionX -= params.p_d / 2 + params.leanF_p_w / 2 - (const_var.lengthData.center.previousLength / 2 + params.leanF_p_w / 2);
		});
		const_var.entry_points.forEach((e) => {
			if (["F_L_R_W", "F_L_R_S_W"].includes(e.component_wall_name)) e.entry_position.positionX -= params.p_d / 2 + params.leanF_p_w / 2 - (const_var.lengthData.center.previousLength / 2 + params.leanF_p_w / 2);
		});
		//
		const_var.newDoorsArray.forEach((e) => {
			if (["G_R_L_L_W", "G_R_L_L_S_W", "G_L_L_L_W", "G_L_L_L_S_W"].includes(e.userData.wallName)) e.positionX += params.p_w / 2 - const_var.lengthData.center.previousWidth / 2;
		});
		const_var.entry_points.forEach((e) => {
			if (["G_R_L_L_W", "G_R_L_L_S_W", "G_L_L_L_W", "G_L_L_L_S_W"].includes(e.component_wall_name)) e.entry_position.positionX += params.p_w / 2 - const_var.lengthData.center.previousWidth / 2;
		});
		const_var.newDoorsArray.forEach((e) => {
			if (["G_R_L_R_W", "G_R_L_R_S_W", "G_L_L_R_W", "G_L_L_R_S_W"].includes(e.userData.wallName)) e.positionX -= params.p_w / 2 - const_var.lengthData.center.previousWidth / 2;
		});
		const_var.entry_points.forEach((e) => {
			if (["G_R_L_R_W", "G_R_L_R_S_W", "G_L_L_R_W", "G_L_L_R_S_W"].includes(e.component_wall_name)) e.entry_position.positionX -= params.p_w / 2 - const_var.lengthData.center.previousWidth / 2;
		});
		//
		const_var.newDoorsArray.forEach((e) => {
			if (["G_F_L_R_W", "G_F_L_R_S_W", "G_B_L_R_W", "G_B_L_R_S_W"].includes(e.userData.wallName)) e.positionX -= params.p_d / 2 - const_var.lengthData.center.previousLength / 2;
		});
		const_var.newDoorsArray.forEach((e) => {
			if (["G_F_L_L_W", "G_F_L_L_S_W", "G_B_L_L_W", "G_B_L_L_S_W"].includes(e.userData.wallName)) e.positionX += params.p_d / 2 - const_var.lengthData.center.previousLength / 2;
		});
		const_var.entry_points.forEach((e) => {
			if (["G_F_L_R_W", "G_F_L_R_S_W", "G_B_L_R_W", "G_B_L_R_S_W"].includes(e.component_wall_name)) e.entry_position.positionX -= params.p_d / 2 - const_var.lengthData.center.previousLength / 2;
		});
		const_var.entry_points.forEach((e) => {
			if (["G_F_L_L_W", "G_F_L_L_S_W", "G_B_L_L_W", "G_B_L_L_S_W"].includes(e.component_wall_name)) e.entry_position.positionX += params.p_d / 2 - const_var.lengthData.center.previousLength / 2;
		});

		lstPos = 0;
		currPos = 0;

		if (params.leantoAlignmentBack == "1") currPos = 0;
		if (params.leantoAlignmentBack == "2") currPos = params.p_w / 2 - params.leanB_p_d / 2;
		if (params.leantoAlignmentBack == "3") currPos = -params.p_w / 2 + params.leanB_p_d / 2;
		if (lstPos != currPos) {
			const diff = currPos - lstPos;
			const_var.entry_points.forEach((e) => {
				if (e.component_wall_name == "B_L_S_W" || e.component_wall_name == "B_L_F_S_W") e.entry_position.x += diff;
			});
		}

		lstPos = 0;
		currPos = 0;

		if (params.leantoAlignmentLeft == "1") currPos = 0;
		if (params.leantoAlignmentLeft == "2") currPos = params.p_d / 2 - params.lean_p_d / 2;
		if (params.leantoAlignmentLeft == "3") currPos = -params.p_d / 2 + params.lean_p_d / 2;
		if (lstPos != currPos) {
			const diff = currPos - lstPos;
			const_var.entry_points.forEach((e) => {
				if (e.component_wall_name == "L_L_L_W" || e.component_wall_name == "L_L_L_S_W" || e.component_wall_name == "L_L_R_S_W") e.entry_position.z += diff;
			});
		}

		lstPos = 0;
		currPos = 0;

		if (params.leantoAlignmentRight == "1") currPos = 0;
		if (params.leantoAlignmentRight == "2") currPos = params.p_d / 2 - params.leanR_p_d / 2;
		if (params.leantoAlignmentRight == "3") currPos = -params.p_d / 2 + params.leanR_p_d / 2;
		if (lstPos != currPos) {
			const diff = currPos - lstPos;
			const_var.entry_points.forEach((e) => {
				if (e.component_wall_name == "R_L_R_W" || e.component_wall_name == "R_L_R_S_W" || e.component_wall_name == "R_L_L_S_W") e.entry_position.z += diff;
			});
		}

		if (!params.isBreezeway) cuBuilding.uUdD();
		else updateBreezewayFrameAndStorages({ option: "buildingLength" }, undefined, Number(params.p_h), Number(params.p_d), "popularSize");
		cuBuilding.leanuUdD();
	}
	if (str == "w" && checkCustomDimension == undefined) {
		const_var.lengthData.center.previousWidth = state.params.p_w;
		state.params.p_w = parseInt(value);
		const_var.UpdatedPriceData.roof_style_price_changed = true;
		const_var.UpdatedPriceData.height_price_changed = true;
		const_var.UpdatedPriceData.certificate_price_changed = true;
		const_var.UpdatedPriceData.front_wall_price_changed = true;
		const_var.UpdatedPriceData.back_wall_price_changed = true;
		const_var.UpdatedPriceData.common_width_changed = true;
		const_var.UpdatedPriceData.wainscot_price_changed = true;
		const_var.UpdatedPriceData.wainscot_price_changed = true;

		const_var.UpdatedPriceData.roof_color_price_changed = true;
		const_var.UpdatedPriceData.wall_color_price_changed = true;
		const_var.UpdatedPriceData.trim_color_price_changed = true;
		const_var.UpdatedPriceData.truss_price_changed = true;
		const_var.UpdatedPriceData.frontLean_truss_price_changed = true;
		const_var.UpdatedPriceData.backLean_truss_price_changed = true;
		const_var.UpdatedPriceData.rightLean_truss_price_changed = true;
		const_var.UpdatedPriceData.leftLean_truss_price_changed = true;
		const_var.UpdatedPriceData.connection_fee_end_changed = true;
		const_var.UpdatedPriceData.common_left_lean_width_changed = true;
		const_var.UpdatedPriceData.common_right_lean_width_changed = true;
		const_var.UpdatedPriceData.common_front_lean_width_changed = true;
		const_var.UpdatedPriceData.common_back_lean_width_changed = true;
		let fLength = params.p_d;
		let fWidth = params.p_w;
		updateBracingSelection("center");
		params.add_front_lean && (fLength += params.leanF_p_w);
		params.add_back_lean && (fLength += params.leanB_p_w);
		params.add_left_lean && (fWidth += params.lean_p_w);
		params.add_right_lean && (fWidth += params.leanR_p_w);
		let diag = new THREE.Vector3(fLength, fWidth, params.p_h).length();
		const_var.controls.maxDistance = diag >= 100 ? 500 : diag * 6;

		if (params.leanStyle.front === "standard" && params.leanF_p_d >= params.p_w) {
			params.leanF_p_d = params.p_w;
		}
		if (params.leanStyle.front === "gable" && params.leanF_p_w >= params.p_w) {
			params.leanF_p_w = params.p_w;
		}
		if (params.leanStyle.back === "standard" && params.leanB_p_d >= params.p_w) {
			params.leanB_p_d = params.p_w;
		}
		if (params.leanStyle.back === "gable" && params.leanB_p_w >= params.p_w) {
			params.leanB_p_w = params.p_w;
		}

		if (params.cB_addStorage_left >= params.p_w) {
			params.cB_addStorage_left = params.p_w - 1;
		}
		if (params.cB_addStorage_right >= params.p_w) {
			params.cB_addStorage_right = params.p_w - 1;
		}

		if (const_var.b_r_p_a[params.b_r_p] != undefined && const_var.b_r_p_a[params.b_r_p].cost_type == "%") {
			const_var.UpdatedPriceData.roof_pitch_price_changed = true;
		}
		const_var.BuildingRoofPitch = [];

		if (state.params.add_left_front_lean_porch == true && state.params.add_right_front_lean_porch == true) {
			const_var.lengthData.frontLean.previousLength = state.params.leanF_p_d;
			state.params.leanF_p_d = state.params.p_w;
			const_var.lengthData.frontLean.length = state.params.leanF_p_d;
		}

		if (state.params.add_right_back_lean_porch == true && state.params.add_left_back_lean_porch == true) {
			const_var.lengthData.backLean.previousLength = state.params.leanB_p_d;
			state.params.leanB_p_d = state.params.p_w;
			const_var.lengthData.backLean.length = state.params.leanB_p_d;
		}

		if (state.params.add_left_front_lean_porch == true && state.params.leantoAlignmentFront != "2" && params.p_w != params.leanF_p_d) {
			state.params.add_left_front_lean_porch = false;
		}

		if (state.params.add_right_front_lean_porch == true && state.params.leantoAlignmentFront != "3" && params.p_w != params.leanF_p_d) {
			state.params.add_right_front_lean_porch = false;
		}

		if (state.params.add_left_back_lean_porch == true && state.params.leantoAlignmentBack != "3" && params.p_w != params.leanB_p_d) {
			state.params.add_left_back_lean_porch = false;
		}

		if (state.params.add_right_back_lean_porch == true && state.params.leantoAlignmentBack != "2" && params.p_w != params.leanB_p_d) {
			state.params.add_right_back_lean_porch = false;
		}
		if (params.isBreezeway) updateBreezewayFrameAndStorages({ option: "buildingWidth" }, undefined, undefined);
		cuBuilding.leanuUdD();

		updateTemplateWidthF();
		updateTemplateWidthB();

		const_var.newDoorsArray.forEach((e) => {
			if (["L_L_F_W", "L_L_F_S_W"].includes(e.userData.wallName)) e.positionX += -params.p_w / 2 - params.lean_p_w / 2 - (-const_var.lengthData.center.previousWidth / 2 - params.lean_p_w / 2);
		});
		const_var.entry_points.forEach((e) => {
			if (["L_L_F_W", "L_L_F_S_W"].includes(e.component_wall_name)) e.entry_position.positionX += -params.p_w / 2 - params.lean_p_w / 2 - (-const_var.lengthData.center.previousWidth / 2 - params.lean_p_w / 2);
		});
		//
		const_var.newDoorsArray.forEach((e) => {
			if (["L_L_B_W", "L_L_B_S_W"].includes(e.userData.wallName)) e.positionX -= -params.p_w / 2 - params.lean_p_w / 2 - (-const_var.lengthData.center.previousWidth / 2 - params.lean_p_w / 2);
		});
		const_var.entry_points.forEach((e) => {
			if (["L_L_B_W", "L_L_B_S_W"].includes(e.component_wall_name)) e.entry_position.positionX -= -params.p_w / 2 - params.lean_p_w / 2 - (-const_var.lengthData.center.previousWidth / 2 - params.lean_p_w / 2);
		});
		//
		const_var.newDoorsArray.forEach((e) => {
			if (["R_L_F_W", "R_L_F_S_W"].includes(e.userData.wallName)) e.positionX += params.p_w / 2 + params.leanR_p_w / 2 - (const_var.lengthData.center.previousWidth / 2 + params.leanR_p_w / 2);
		});
		const_var.entry_points.forEach((e) => {
			if (["R_L_F_W", "R_L_F_S_W"].includes(e.component_wall_name)) e.entry_position.positionX += params.p_w / 2 + params.leanR_p_w / 2 - (const_var.lengthData.center.previousWidth / 2 + params.leanR_p_w / 2);
		});
		//
		const_var.newDoorsArray.forEach((e) => {
			if (["R_L_B_W", "R_L_B_S_W"].includes(e.userData.wallName)) e.positionX -= params.p_w / 2 + params.leanR_p_w / 2 - (const_var.lengthData.center.previousWidth / 2 + params.leanR_p_w / 2);
		});
		const_var.entry_points.forEach((e) => {
			if (["R_L_B_W", "R_L_B_S_W"].includes(e.component_wall_name)) e.entry_position.positionX -= params.p_w / 2 + params.leanR_p_w / 2 - (const_var.lengthData.center.previousWidth / 2 + params.leanR_p_w / 2);
		});
		//
		const_var.newDoorsArray.forEach((e) => {
			if (["G_R_L_L_W", "G_R_L_L_S_W", "G_L_L_L_W", "G_L_L_L_S_W"].includes(e.userData.wallName)) e.positionX += params.p_w / 2 - const_var.lengthData.center.previousWidth / 2;
		});
		const_var.entry_points.forEach((e) => {
			if (["G_R_L_L_W", "G_R_L_L_S_W", "G_L_L_L_W", "G_L_L_L_S_W"].includes(e.component_wall_name)) e.entry_position.positionX += params.p_w / 2 - const_var.lengthData.center.previousWidth / 2;
		});
		const_var.newDoorsArray.forEach((e) => {
			if (["G_R_L_R_W", "G_R_L_R_S_W", "G_L_L_R_W", "G_L_L_R_S_W"].includes(e.userData.wallName)) e.positionX -= params.p_w / 2 - const_var.lengthData.center.previousWidth / 2;
		});
		const_var.entry_points.forEach((e) => {
			if (["G_R_L_R_W", "G_R_L_R_S_W", "G_L_L_R_W", "G_L_L_R_S_W"].includes(e.component_wall_name)) e.entry_position.positionX -= params.p_w / 2 - const_var.lengthData.center.previousWidth / 2;
		});

		let lstPos = 0;
		let currPos = 0;

		if (params.leantoAlignmentFront == "1") currPos = 0;
		if (params.leantoAlignmentFront == "3") currPos = params.p_w / 2 - params.leanF_p_d / 2;
		if (params.leantoAlignmentFront == "2") currPos = -params.p_w / 2 + params.leanF_p_d / 2;
		if (lstPos != currPos) {
			const diff = currPos - lstPos;
			const_var.entry_points.forEach((e) => {
				if (e.component_wall_name == "F_L_F_W" || e.component_wall_name == "F_L_F_S_W") e.entry_position.x += diff;
			});
		}

		lstPos = 0;
		currPos = 0;

		if (params.leantoAlignmentBack == "1") currPos = 0;
		if (params.leantoAlignmentBack == "2") currPos = params.p_w / 2 - params.leanB_p_d / 2;
		if (params.leantoAlignmentBack == "3") currPos = -params.p_w / 2 + params.leanB_p_d / 2;
		if (lstPos != currPos) {
			const diff = currPos - lstPos;
			const_var.entry_points.forEach((e) => {
				if (e.component_wall_name == "B_L_S_W" || e.component_wall_name == "B_L_F_S_W") e.entry_position.x += diff;
			});
		}
	} else if (str == "l" && checkCustomDimension == undefined) {
		const_var.lengthData.center.previousLength = state.params.p_d;
		state.params.p_d = parseInt(value);
		const_var.lengthData.center.length = state.params.p_d;
		if (state.params.p_d > state.const_var.arrayendLengthRoof[params.p_r_s] && "Vertical" != state.const_var.TypeEnum[state.params.p_r_s]) {
			state.params.p_r_s = 3;
			for (var i = 0; i <= const_var.roof_style.length - 1; i++) {
				if (state.const_var.roof_style[i].roof_id == state.params.p_r_s) {
					roofStyleChange(state, i, true, true);
				}
			}
		}

		const_var.UpdatedPriceData.connection_fee_end_changed = true;
		const_var.UpdatedPriceData.left_front_wrap_connection_fee_changed = true;
		const_var.UpdatedPriceData.right_front_wrap_connection_fee_changed = true;
		const_var.UpdatedPriceData.right_back_wrap_connection_fee_changed = true;
		const_var.UpdatedPriceData.left_back_wrap_connection_fee_changed = true;
		const_var.UpdatedPriceData.roof_style_price_changed = true;
		const_var.UpdatedPriceData.height_price_changed = true;
		const_var.UpdatedPriceData.roof_pitch_price_changed = true;
		const_var.UpdatedPriceData.certificate_price_changed = true;
		const_var.UpdatedPriceData.right_wall_price_changed = true;
		const_var.UpdatedPriceData.left_wall_price_changed = true;
		const_var.UpdatedPriceData.left_wall_cut_panel_price_changed = true;
		const_var.UpdatedPriceData.front_wall_price_changed = true;
		const_var.UpdatedPriceData.front_wall_cut_panel_price_changed = true;
		const_var.UpdatedPriceData.right_wall_cut_panel_price_changed = true;
		const_var.UpdatedPriceData.common_length_changed = true;
		const_var.UpdatedPriceData.wainscot_price_changed = true;
		const_var.UpdatedPriceData.wainscot_price_changed = true;

		const_var.UpdatedPriceData.roof_color_price_changed = true;
		const_var.UpdatedPriceData.wall_color_price_changed = true;
		const_var.UpdatedPriceData.trim_color_price_changed = true;
		const_var.UpdatedPriceData.truss_price_changed = true;
		const_var.UpdatedPriceData.frontLean_truss_price_changed = true;
		const_var.UpdatedPriceData.backLean_truss_price_changed = true;
		const_var.UpdatedPriceData.rightLean_truss_price_changed = true;
		const_var.UpdatedPriceData.leftLean_truss_price_changed = true;
		const_var.UpdatedPriceData.common_left_lean_length_changed = true;
		const_var.UpdatedPriceData.common_right_lean_length_changed = true;
		const_var.UpdatedPriceData.common_front_lean_length_changed = true;
		const_var.UpdatedPriceData.common_back_lean_length_changed = true;
		let fLength = params.p_d;
		let fWidth = params.p_w;
		params.add_front_lean && (fLength += params.leanF_p_w);
		params.add_back_lean && (fLength += params.leanB_p_w);
		params.add_left_lean && (fWidth += params.lean_p_w);
		params.add_right_lean && (fWidth += params.leanR_p_w);
		let diag = new THREE.Vector3(fLength, fWidth, params.p_h).length();
		const_var.controls.maxDistance = diag >= 100 ? 500 : diag * 6;

		if (state.params.add_left_front_lean_porch == true && state.params.add_left_back_lean_porch == true) {
			const_var.lengthData.leftLean.previousLength = state.params.lean_p_d;
			state.params.lean_p_d = state.params.p_d;
			const_var.lengthData.leftLean.length = state.params.lean_p_d;
		}

		if (state.params.add_right_back_lean_porch == true && state.params.add_right_front_lean_porch == true) {
			const_var.lengthData.rightLean.previousLength = state.params.leanR_p_d;
			state.params.leanR_p_d = state.params.p_d;
			const_var.lengthData.rightLean.length = state.params.leanR_p_d;
		}

		if (params.leanStyle.left === "gable" && params.lean_p_w >= params.p_d) {
			params.lean_p_w = params.p_d;
		}
		if (params.leanStyle.right === "gable" && params.leanR_p_w >= params.p_d) {
			params.leanR_p_w = params.p_d;
		}

		if (params.p_u_c) {
			const_var.newDoorsArray.forEach((e) => {
				if (e.userData.wallName == "c_b_r_s_w") {
					e.positionX += (params.p_d - const_var.lengthData.center.previousLength) / 2;
				} else if (e.userData.wallName == "c_b_l_s_w") {
					e.positionX += (const_var.lengthData.center.previousLength - params.p_d) / 2;
				}
			});
		}

		const_var.newDoorsArray.forEach((e) => {
			if (["B_L_B_W", "B_L_R_S_W"].includes(e.userData.wallName)) e.positionX += -params.p_d / 2 - params.leanB_p_w / 2 - (-const_var.lengthData.center.previousLength / 2 - params.leanB_p_w / 2);
		});

		const_var.newDoorsArray.forEach((e) => {
			if (["B_L_F_W", "B_L_L_S_W"].includes(e.userData.wallName)) e.positionX -= -params.p_d / 2 - params.leanB_p_w / 2 - (-const_var.lengthData.center.previousLength / 2 - params.leanB_p_w / 2);
		});

		const_var.newDoorsArray.forEach((e) => {
			if (["F_L_L_W", "F_L_L_S_W"].includes(e.userData.wallName)) e.positionX += params.p_d / 2 + params.leanF_p_w / 2 - (const_var.lengthData.center.previousLength / 2 + params.leanF_p_w / 2);
		});

		const_var.newDoorsArray.forEach((e) => {
			if (["F_L_R_W", "F_L_R_S_W"].includes(e.userData.wallName)) e.positionX -= params.p_d / 2 + params.leanF_p_w / 2 - (const_var.lengthData.center.previousLength / 2 + params.leanF_p_w / 2);
		});

		const_var.newDoorsArray.forEach((e) => {
			if (["G_F_L_R_W", "G_F_L_R_S_W", "G_B_L_R_W", "G_B_L_R_S_W"].includes(e.userData.wallName)) e.positionX -= params.p_d / 2 - const_var.lengthData.center.previousLength / 2;
		});
		const_var.newDoorsArray.forEach((e) => {
			if (["G_F_L_L_W", "G_F_L_L_S_W", "G_B_L_L_W", "G_B_L_L_S_W"].includes(e.userData.wallName)) e.positionX += params.p_d / 2 - const_var.lengthData.center.previousLength / 2;
		});

		const_var.entry_points.forEach((e) => {
			if (["B_L_B_W", "B_L_R_S_W"].includes(e.component_wall_name)) e.entry_position.positionX += -params.p_d / 2 - params.leanB_p_w / 2 - (-const_var.lengthData.center.previousLength / 2 - params.leanB_p_w / 2);
		});

		const_var.entry_points.forEach((e) => {
			if (["B_L_F_W", "B_L_L_S_W"].includes(e.component_wall_name)) e.entry_position.positionX -= -params.p_d / 2 - params.leanB_p_w / 2 - (-const_var.lengthData.center.previousLength / 2 - params.leanB_p_w / 2);
		});

		const_var.entry_points.forEach((e) => {
			if (["F_L_L_W", "F_L_L_S_W"].includes(e.component_wall_name)) e.entry_position.positionX += params.p_d / 2 + params.leanF_p_w / 2 - (const_var.lengthData.center.previousLength / 2 + params.leanF_p_w / 2);
		});

		const_var.entry_points.forEach((e) => {
			if (["F_L_R_W", "F_L_R_S_W"].includes(e.component_wall_name)) e.entry_position.positionX -= params.p_d / 2 + params.leanF_p_w / 2 - (const_var.lengthData.center.previousLength / 2 + params.leanF_p_w / 2);
		});

		const_var.entry_points.forEach((e) => {
			if (["G_F_L_R_W", "G_F_L_R_S_W", "G_B_L_R_W", "G_B_L_R_S_W"].includes(e.component_wall_name)) e.entry_position.positionX -= params.p_d / 2 - const_var.lengthData.center.previousLength / 2;
		});
		const_var.entry_points.forEach((e) => {
			if (["G_F_L_L_W", "G_F_L_L_S_W", "G_B_L_L_W", "G_B_L_L_S_W"].includes(e.component_wall_name)) e.entry_position.positionX += params.p_d / 2 - const_var.lengthData.center.previousLength / 2;
		});

		let lstPos = 0;
		let currPos = 0;

		if (params.leantoAlignmentLeft == "1") currPos = 0;
		if (params.leantoAlignmentLeft == "2") currPos = params.p_d / 2 - params.lean_p_d / 2;
		if (params.leantoAlignmentLeft == "3") currPos = -params.p_d / 2 + params.lean_p_d / 2;
		if (lstPos != currPos) {
			const diff = currPos - lstPos;
			const_var.entry_points.forEach((e) => {
				if (e.component_wall_name == "L_L_L_W" || e.component_wall_name == "L_L_L_S_W" || e.component_wall_name == "L_L_R_S_W") e.entry_position.z += diff;
			});
		}

		lstPos = 0;
		currPos = 0;

		if (params.leantoAlignmentRight == "1") currPos = 0;
		if (params.leantoAlignmentRight == "2") currPos = params.p_d / 2 - params.leanR_p_d / 2;
		if (params.leantoAlignmentRight == "3") currPos = -params.p_d / 2 + params.leanR_p_d / 2;
		if (lstPos != currPos) {
			const diff = currPos - lstPos;
			const_var.entry_points.forEach((e) => {
				if (e.component_wall_name == "R_L_R_W" || e.component_wall_name == "R_L_R_S_W" || e.component_wall_name == "R_L_L_S_W") e.entry_position.z += diff;
			});
		}

		if (params.add_right_lean) makeDimensionUpdateRight(state);
		if (params.add_left_lean) makeDimensionUpdateLeft(state);
		if (params.add_front_lean) makeDimensionUpdateFront(state);
		if (params.add_back_lean) makeDimensionUpdateBack(state);
		if (!params.isBreezeway) {
			cuBuilding.uUdD();
		} else {
			updateBreezewayFrameAndStorages({ option: "buildingLength" }, undefined, Number(params.p_h), Number(params.p_d));
		}
		if (params.add_front_lean || params.add_left_lean || params.add_right_lean || params.add_back_lean) {
			cuBuilding.leanuUdD();
		}

		if (state.params.add_left_front_lean_porch == true && state.params.leantoAlignmentLeft != "2" && params.p_d != params.lean_p_d) {
			state.params.add_left_front_lean_porch = false;
		}

		if (state.params.add_left_back_lean_porch == true && state.params.leantoAlignmentLeft != "3" && params.p_d != params.lean_p_d) {
			state.params.add_left_back_lean_porch = false;
		}

		if (state.params.add_right_front_lean_porch == true && state.params.leantoAlignmentRight != "2" && params.p_d != params.lean_p_d) {
			state.params.add_right_front_lean_porch = false;
		}

		if (state.params.add_right_back_lean_porch == true && state.params.leantoAlignmentRight != "3" && params.p_d != params.lean_p_d) {
			state.params.add_right_back_lean_porch = false;
		}

		utils.prepareLoftDropdown();
	} else if (str == "h" || (from != undefined && from.str == "h" && from?.cmp == "popularSizes")) {
		state.params.p_h = from != undefined && from?.cmp == "popularSizes" ? from.val : parseInt(value);
		updateBracingSelection("center");

		if (isNaN(params.p_l_w) == false && Math.abs(params.p_l_w) * 3 >= params.p_h) {
			params.p_l_w = "Close";
		}
		if (isNaN(params.p_r_w) == false && Math.abs(params.p_r_w) * 3 >= params.p_h) {
			params.p_r_w = "Close";
		}
		makeDimensionArray(state, { changeBuildingDimension });

		const_var.UpdatedPriceData.connection_fee_end_changed = true;
		const_var.UpdatedPriceData.height_price_changed = true;
		const_var.UpdatedPriceData.certificate_price_changed = true;
		const_var.UpdatedPriceData.right_wall_price_changed = true;
		const_var.UpdatedPriceData.left_wall_price_changed = true;
		const_var.UpdatedPriceData.left_wall_cut_panel_price_changed = true;
		const_var.UpdatedPriceData.right_wall_cut_panel_price_changed = true;
		const_var.UpdatedPriceData.front_wall_price_changed = true;
		const_var.UpdatedPriceData.back_wall_price_changed = true;
		const_var.UpdatedPriceData.utility_price_changed = true;
		const_var.UpdatedPriceData.front_utility_price_changed = true;
		const_var.UpdatedPriceData.common_height_changed = true;
		const_var.UpdatedPriceData.lifttype_price_changed = true;

		if (params.add_left_lean == true && const_var.leanGetDataLeft.central_side != undefined && const_var.leanGetDataLeft.central_side.length > 0) {
			const_var.leanGetDataLeft.central_side = [];
			const_var.leanGetDataLeft.central_end = [];
		}
		if (params.add_right_lean == true && const_var.leanGetDataRight.central_side != undefined && const_var.leanGetDataRight.central_side.length > 0) {
			const_var.leanGetDataRight.central_side = [];
			const_var.leanGetDataRight.central_end = [];
		}
		params.p_e_l = false;
		makeDimensionUpdateRight(state);
		makeDimensionUpdateLeft(state);
		makeDimensionUpdateFront(state);
		makeDimensionUpdateBack(state);
		const_var.UpdatedPriceData.certificate_price_changed = true;
		cuBuilding.CheckLeanLegsByResponse(state, "all");
		cuBuilding.CheckLegsByResponse(state);
		updateJTrim();
		if (params.isBreezeway) updateBreezewayFrameAndStorages({ option: "buildingHeight" }, undefined, Number(params.p_h));
		const_var.commonBuildingFlag.center.buildingHeightChk = true;
		const_var.commonBuildingFlag.center.buildingHeight = true;
		const_var.UpdatedPriceData.connection_fee_end_changed = true;
	} else if (str == "lean_w") {
		state.params.lean_p_w = parseInt(value);
		const_var.UpdatedPriceData.left_lean_roof_style_price_changed = true;
		const_var.UpdatedPriceData.certificate_price_changed = true;
		const_var.UpdatedPriceData.left_lean_front_wall_price_changed = true;
		const_var.UpdatedPriceData.left_lean_back_wall_price_changed = true;
		const_var.UpdatedPriceData.connection_fee_end_changed = true;
		const_var.UpdatedPriceData.wainscot_price_changed = true;

		if (const_var.isLTBuilding) {
			updateBracingSelection("left");
		}

		if (state.params.add_left_front_lean_porch != false && state.params.leanF_p_w != state.params.lean_p_w) {
			state.params.add_left_front_lean_porch = false;
		}

		if (state.params.add_left_back_lean_porch != false && state.params.leanB_p_w != state.params.lean_p_w) {
			state.params.add_left_back_lean_porch = false;
		}

		if (state.params.add_right_front_lean_porch != false && state.params.add_left_front_lean_porch == true && state.params.lean_p_w != state.params.leanR_p_w) {
			state.params.add_right_front_lean_porch = false;
		}

		if (state.params.add_right_back_lean_porch != false && state.params.add_left_back_lean_porch == true && state.params.lean_p_w != state.params.leanR_p_w) {
			state.params.add_right_back_lean_porch = false;
		}

		if (const_var.b_r_p_a[params.b_r_p] != undefined && const_var.b_r_p_a[params.b_r_p].cost_type == "%") {
			const_var.UpdatedPriceData.left_lean_roof_pitch_price_changed = true;
		}
		cuBuilding.UpdateLeftLean();
		updateTemplateWidthL();
	} else if (str == "lean_l") {
		const_var.lengthData.leftLean.previousLength = state.params.lean_p_d;
		state.params.lean_p_d = parseInt(value);
		const_var.lengthData.leftLean.length = state.params.lean_p_d;

		const_var.UpdatedPriceData.left_lean_roof_style_price_changed = true;
		const_var.UpdatedPriceData.left_lean_height_price_changed = true;
		const_var.UpdatedPriceData.left_lean_roof_pitch_price_changed = true;
		const_var.UpdatedPriceData.certificate_price_changed = true;
		const_var.UpdatedPriceData.left_lean_left_wall_price_changed = true;
		const_var.UpdatedPriceData.left_lean_right_wall_price_changed = true;
		const_var.UpdatedPriceData.wainscot_price_changed = true;
		if (state.params.add_left_front_lean_porch != false && state.params.leantoAlignmentLeft != "2") {
			state.params.add_left_front_lean_porch = false;
		}

		if (state.params.add_left_back_lean_porch != false && state.params.leantoAlignmentLeft != "3") {
			state.params.add_left_back_lean_porch = false;
		}

		cuBuilding.UpdateLeftLean();

		utils.prepareLoftDropdown();
		cuBuilding.leanuUdD(state);
	} else if (str == "lean_h") {
		state.params.lean_p_h = parseInt(value);

		const_var.UpdatedPriceData.left_lean_height_price_changed = true;
		const_var.UpdatedPriceData.certificate_price_changed = true;
		const_var.UpdatedPriceData.left_lean_left_wall_price_changed = true;
		const_var.UpdatedPriceData.left_lean_right_wall_price_changed = true;
		const_var.UpdatedPriceData.left_lean_front_wall_price_changed = true;
		const_var.UpdatedPriceData.left_lean_back_wall_price_changed = true;
		const_var.UpdatedPriceData.left_lean_utility_price_changed = true;

		if (const_var.isLTBuilding) {
			updateBracingSelection("left");
		}
		if (state.params.add_left_front_lean_porch != false && state.params.leanF_p_h != state.params.lean_p_h) {
			state.params.add_left_front_lean_porch = false;
		}

		if (state.params.add_left_back_lean_porch != false && state.params.leanB_p_h != state.params.lean_p_h) {
			state.params.add_left_back_lean_porch = false;
		}

		if (state.params.add_right_front_lean_porch != false && state.params.add_left_front_lean_porch == true && state.params.lean_p_h != state.params.leanR_p_h) {
			state.params.add_right_front_lean_porch = false;
		}

		if (state.params.add_right_back_lean_porch != false && state.params.add_left_back_lean_porch == true && state.params.lean_p_h != state.params.leanR_p_h) {
			state.params.add_right_back_lean_porch = false;
		}
		cuBuilding.UpdateLeftLean();
		updateTemplateWidthL();
		const_var.commonBuildingFlag.leftLean.leftLeanHeight = valueToSet != undefined ? valueToSet : true;
	} else if (str == "leanR_w") {
		state.params.leanR_p_w = parseInt(value);
		const_var.UpdatedPriceData.right_lean_roof_style_price_changed = true;
		const_var.UpdatedPriceData.certificate_price_changed = true;
		const_var.UpdatedPriceData.right_lean_front_wall_price_changed = true;
		const_var.UpdatedPriceData.right_lean_back_wall_price_changed = true;
		const_var.UpdatedPriceData.connection_fee_end_changed = true;
		const_var.UpdatedPriceData.wainscot_price_changed = true;

		if (const_var.isLTBuilding) {
			updateBracingSelection("right");
		}

		if (state.params.add_right_front_lean_porch != false && state.params.leanF_p_w != state.params.leanR_p_w) {
			state.params.add_right_front_lean_porch = false;
		}

		if (state.params.add_right_back_lean_porch != false && state.params.leanB_p_w != state.params.leanR_p_w) {
			state.params.add_right_back_lean_porch = false;
		}

		if (state.params.add_left_front_lean_porch != false && state.params.add_right_front_lean_porch == true && state.params.lean_p_w != state.params.leanR_p_w) {
			state.params.add_left_front_lean_porch = false;
		}

		if (state.params.add_left_back_lean_porch != false && state.params.add_right_back_lean_porch == true && state.params.lean_p_w != state.params.leanR_p_w) {
			state.params.add_left_back_lean_porch = false;
		}

		if (const_var.b_r_p_a[params.b_r_p] != undefined && const_var.b_r_p_a[params.b_r_p].cost_type == "%") {
			const_var.UpdatedPriceData.right_lean_roof_pitch_price_changed = true;
		}
		cuBuilding.UpdateRightLean();
		updateTemplateWidthR();
	} else if (str == "leanR_l") {
		const_var.lengthData.rightLean.previousLength = state.params.leanR_p_d;
		state.params.leanR_p_d = parseInt(value);
		const_var.lengthData.rightLean.length = state.params.leanR_p_d;

		const_var.UpdatedPriceData.right_lean_roof_style_price_changed = true;
		const_var.UpdatedPriceData.right_lean_height_price_changed = true;
		const_var.UpdatedPriceData.right_lean_roof_pitch_price_changed = true;
		const_var.UpdatedPriceData.certificate_price_changed = true;
		const_var.UpdatedPriceData.right_lean_right_wall_price_changed = true;
		const_var.UpdatedPriceData.right_lean_left_wall_price_changed = true;
		const_var.UpdatedPriceData.wainscot_price_changed = true;

		if (state.params.add_right_front_lean_porch != false && state.params.leantoAlignmentRight != "2") {
			state.params.add_right_front_lean_porch = false;
		}

		if (state.params.add_right_back_lean_porch != false && state.params.leantoAlignmentRight != "3") {
			state.params.add_right_back_lean_porch = false;
		}

		let wNames = ["R_L_R_S_W", "R_L_L_S_W"];

		cuBuilding.UpdateRightLean();
		cuBuilding.leanuUdD(state);
	} else if (str == "leanR_h") {
		state.params.leanR_p_h = parseInt(value);

		const_var.UpdatedPriceData.right_lean_height_price_changed = true;
		const_var.UpdatedPriceData.certificate_price_changed = true;
		const_var.UpdatedPriceData.right_lean_right_wall_price_changed = true;
		const_var.UpdatedPriceData.right_lean_left_wall_price_changed = true;
		const_var.UpdatedPriceData.right_lean_front_wall_price_changed = true;
		const_var.UpdatedPriceData.right_lean_back_wall_price_changed = true;
		const_var.UpdatedPriceData.right_lean_utility_price_changed = true;
		if (const_var.isLTBuilding) {
			updateBracingSelection("right");
		}

		if (state.params.add_right_front_lean_porch != false) {
			state.params.add_right_front_lean_porch = false;
		}

		if (state.params.add_right_back_lean_porch != false) {
			state.params.add_right_back_lean_porch = false;
		}
		cuBuilding.UpdateRightLean();
		updateTemplateWidthR();
		const_var.commonBuildingFlag.rightLean.rightLeanHeight = valueToSet != undefined ? valueToSet : true;
	} else if (str == "leanF_w") {
		state.params.leanF_p_w = parseInt(value);

		const_var.UpdatedPriceData.front_lean_roof_style_price_changed = true;
		const_var.UpdatedPriceData.certificate_price_changed = true;
		const_var.UpdatedPriceData.front_lean_front_wall_price_changed = true;
		const_var.UpdatedPriceData.front_lean_back_wall_price_changed = true;
		const_var.UpdatedPriceData.connection_fee_end_changed = true;
		const_var.UpdatedPriceData.wainscot_price_changed = true;

		if (const_var.isLTBuilding) {
			updateBracingSelection("front");
		}

		if (state.params.add_left_front_lean_porch != false) {
			state.params.add_left_front_lean_porch = false;
		}

		if (state.params.add_right_front_lean_porch != false) {
			state.params.add_right_front_lean_porch = false;
		}
		if (const_var.b_r_p_a[params.b_r_p] != undefined && const_var.b_r_p_a[params.b_r_p].cost_type == "%") {
			const_var.UpdatedPriceData.front_lean_roof_pitch_price_changed = true;
		}
		cuBuilding.UpdateFrontLean();
		updateTemplateWidthF();
	} else if (str == "leanF_l") {
		const_var.lengthData.frontLean.previousLength = state.params.leanF_p_d;
		state.params.leanF_p_d = parseInt(value);
		const_var.lengthData.frontLean.length = state.params.leanF_p_d;
		const_var.UpdatedPriceData.roof_style_price_changed = true;
		const_var.UpdatedPriceData.certificate_price_changed = true;
		const_var.UpdatedPriceData.front_wall_price_changed = true;
		const_var.UpdatedPriceData.back_wall_price_changed = true;
		const_var.UpdatedPriceData.common_width_changed = true;
		const_var.UpdatedPriceData.wainscot_price_changed = true;
		if (state.params.add_left_front_lean_porch != false && state.params.leantoAlignmentFront != "2" && params.leanF_p_d != params.p_w) {
			state.params.add_left_front_lean_porch = false;
		}

		if (state.params.add_right_front_lean_porch != false && state.params.leantoAlignmentFront != "3" && params.leanF_p_d != params.p_w) {
			state.params.add_right_front_lean_porch = false;
		}

		if (const_var.b_r_p_a[params.b_r_p] != undefined && const_var.b_r_p_a[params.b_r_p].cost_type == "%") {
			const_var.UpdatedPriceData.roof_pitch_price_changed = true;
		}

		cuBuilding.UpdateFrontLean();
		cuBuilding.leanuUdD(state);

		if (Object.keys(const_var.FrontLeandrop_arr).length == 0 && params.add_storage_check_front) {
			params.add_storage_check_front = false;
			state.isFullyEnclosedCheckedForFrontLeanTo ? (params.p_b_c_b_f_b = "Close") : (params.p_b_c_b_f_b = "Open");
		}
	} else if (str == "leanF_h") {
		state.params.leanF_p_h = parseInt(value);

		const_var.UpdatedPriceData.front_lean_height_price_changed = true;
		const_var.UpdatedPriceData.certificate_price_changed = true;
		const_var.UpdatedPriceData.front_lean_left_wall_price_changed = true;
		const_var.UpdatedPriceData.front_lean_right_wall_price_changed = true;
		const_var.UpdatedPriceData.front_lean_front_wall_price_changed = true;
		const_var.UpdatedPriceData.front_lean_back_wall_price_changed = true;
		const_var.UpdatedPriceData.front_lean_utility_price_changed = true;
		if (const_var.isLTBuilding) {
			updateBracingSelection("front");
		}

		if (state.params.add_left_front_lean_porch != false) {
			state.params.add_left_front_lean_porch = false;
		}

		if (state.params.add_right_front_lean_porch != false) {
			state.params.add_right_front_lean_porch = false;
		}
		cuBuilding.UpdateFrontLean();
		updateTemplateWidthF();
		const_var.commonBuildingFlag.frontLean.frontLeanHeight = valueToSet != undefined ? valueToSet : true;
	} else if (str == "leanB_w") {
		state.params.leanB_p_w = parseInt(value);
		const_var.UpdatedPriceData.back_lean_roof_style_price_changed = true;
		const_var.UpdatedPriceData.certificate_price_changed = true;
		const_var.UpdatedPriceData.back_lean_front_wall_price_changed = true;
		const_var.UpdatedPriceData.back_lean_right_wall_price_changed = true;
		const_var.UpdatedPriceData.connection_fee_end_changed = true;
		const_var.UpdatedPriceData.wainscot_price_changed = true;

		if (const_var.isLTBuilding) {
			updateBracingSelection("back");
		}

		if (state.params.add_left_back_lean_porch != false) {
			state.params.add_left_back_lean_porch = false;
		}

		if (state.params.add_right_back_lean_porch != false) {
			state.params.add_right_back_lean_porch = false;
		}
		if (const_var.b_r_p_a[params.b_r_p] != undefined && const_var.b_r_p_a[params.b_r_p].cost_type == "%") {
			const_var.UpdatedPriceData.back_lean_roof_pitch_price_changed = true;
		}
		updateTemplateWidthB();
		cuBuilding.UpdateBackLean();
	} else if (str == "leanB_l") {
		const_var.lengthData.backLean.previousLength = state.params.leanB_p_d;
		state.params.leanB_p_d = parseInt(value);
		const_var.lengthData.backLean.length = state.params.leanB_p_d;

		const_var.UpdatedPriceData.roof_style_price_changed = true;
		const_var.UpdatedPriceData.certificate_price_changed = true;
		const_var.UpdatedPriceData.front_wall_price_changed = true;
		const_var.UpdatedPriceData.back_wall_price_changed = true;
		const_var.UpdatedPriceData.common_width_changed = true;
		const_var.UpdatedPriceData.wainscot_price_changed = true;
		if (state.params.add_left_back_lean_porch != false && state.params.leantoAlignmentBack != "3" && params.leanB_p_d != params.p_w) {
			state.params.add_left_back_lean_porch = false;
		}

		if (state.params.add_right_back_lean_porch != false && state.params.leantoAlignmentBack != "2" && params.leanB_p_d != params.p_w) {
			state.params.add_right_back_lean_porch = false;
		}

		if (const_var.b_r_p_a[params.b_r_p] != undefined && const_var.b_r_p_a[params.b_r_p].cost_type == "%") {
			const_var.UpdatedPriceData.roof_pitch_price_changed = true;
		}

		cuBuilding.UpdateBackLean();
		cuBuilding.leanuUdD(state);

		if (Object.keys(const_var.BackLeandrop_arr).length == 0 && params.add_storage_check_back) {
			params.add_storage_check_back = false;
			state.isFullyEnclosedCheckedForBackLeanTo ? (params.p_b_c_b_b_b = "Close") : (params.p_b_c_b_b_b = "Open");
		}
	} else if (str == "leanB_h") {
		state.params.leanB_p_h = parseInt(value);

		const_var.UpdatedPriceData.back_lean_height_price_changed = true;
		const_var.UpdatedPriceData.certificate_price_changed = true;
		const_var.UpdatedPriceData.back_lean_left_wall_price_changed = true;
		const_var.UpdatedPriceData.back_lean_right_wall_price_changed = true;
		const_var.UpdatedPriceData.back_lean_front_wall_price_changed = true;
		const_var.UpdatedPriceData.back_lean_left_wall_price_changed = true;
		const_var.UpdatedPriceData.back_lean_utility_price_changed = true;
		if (const_var.isLTBuilding) {
			updateBracingSelection("back");
		}

		if (state.params.add_left_back_lean_porch != false) {
			state.params.add_left_back_lean_porch = false;
		}

		if (state.params.add_right_back_lean_porch != false) {
			state.params.add_right_back_lean_porch = false;
		}
		updateTemplateWidthB();
		cuBuilding.UpdateBackLean();
		const_var.commonBuildingFlag.backLean.backLeanHeight = valueToSet != undefined ? valueToSet : true;
	}

	if (const_var.loginSession == false) {
		reSelExtEle(state);
	}
	dynamicWallOptions(state);
	dynamicWallOptionsForLeanTo(state);
	if (state.params.add_front_lean == true || state.params.p_r_s == "4" || state.params.p_r_s == "5") {
		state.params.p_f_w = state.params.p_f_w == "Close" || state.params.p_f_w == "Open" ? state.params.p_f_w : params.a_c_p_f == false ? state.params.p_f_w : state.params.p_f_w;
	}
	if (state.params.add_left_lean == true || state.params.p_r_s == "4" || state.params.p_r_s == "5") {
		state.params.p_l_w = state.params.p_l_w == "Close" || state.params.p_l_w == "Open" ? state.params.p_l_w : params.a_c_p_l == false ? 1 : state.params.p_l_w;
	}
	if (state.params.add_right_lean == true || state.params.p_r_s == "4" || state.params.p_r_s == "5") {
		state.params.p_r_w = state.params.p_r_w == "Close" || state.params.p_r_w == "Open" ? state.params.p_r_w : params.a_c_p_r == false ? 1 : state.params.p_r_w;
	}

	if (params.checkeditName != true) {
		let newVal = params.building_type_name + " - " + params.p_w + " x " + params.p_d + " x " + params.p_h;
		params.other_building_type_name = newVal;
		if (const_var.post_data.building != undefined) {
			const_var.post_data.building.other_building_type_name = params.other_building_type_name;
			const_var.post_data.building.name = params.other_building_type_name;
		}
	}

	cuBuilding.uUdDCB();

	if (const_var.callMesure == true) {
		if (params.add_front_lean || params.add_back_lean || params.add_left_lean || params.add_right_lean) {
		}
	}
	const_var.UpdatedPriceData.wainscot_price_changed = true;

	const_var.UpdatedPriceData.roof_color_price_changed = true;
	const_var.UpdatedPriceData.wall_color_price_changed = true;
	const_var.UpdatedPriceData.trim_color_price_changed = true;
	utils.installationSurface(state.params.p_i_s);
	cuBuilding.BuildingUpdate(true);
};
